import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { effects, selectors } from 'lib/entities/credentials';

//  Utils
import auth from 'utils/auth';

function useProtectedRoute() {
  const [isLoaded, setIsLoaded] = useState(false);
  const router = useRouter();
  const dispatch = useDispatch();
  const { isLoggedIn } = useSelector(selectors);

  useEffect(() => {
    const token = auth.getToken();
    if (!isLoggedIn && !token?.accessToken?.token) {
      // @ts-ignore
      dispatch(effects.logout());
      router.push('/login');
      return;
    }
    setIsLoaded(true);
  }, [dispatch, isLoggedIn, router]);

  return { isLoaded };
}

export default useProtectedRoute;
